var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup466(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.249,
    height: 18.445,
    viewBox: "0 0 18.249 18.445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c{fill:#fbcc8e;stroke:#fbcc8e;stroke-miterlimit:10;}.a{stroke-width:0.979px;}.b{stroke-width:1.305px;}.c{stroke-linecap:round;stroke-width:2.61px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-114.559 -62.011)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.62,
    cy: 1.62,
    r: 1.62,
    transform: "translate(119.036 67.516)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.62,
    cy: 1.62,
    r: 1.62,
    transform: "translate(115.132 63.437)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.62,
    cy: 1.62,
    r: 1.62,
    transform: "translate(129.079 62.57)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.62,
    cy: 1.62,
    r: 1.62,
    transform: "translate(127.836 76.306)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.62,
    cy: 1.62,
    r: 1.62,
    transform: "translate(115.211 76.047)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    y1: 4.541,
    x2: 9.695,
    transform: "translate(120.656 64.594)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 12.488,
    y2: 13.157,
    transform: "translate(116.939 65.454)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(116.223 62.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M140.421,176.614l-5.894-14.039a.766.766,0,0,0-.791-.575h-.072a.847.847,0,0,0-.839.575l-5.846,14.039a1.171,1.171,0,0,0-.072.359.677.677,0,0,0,.456.623,1.016,1.016,0,0,0,.359.071.651.651,0,0,0,.623-.479l1.485-3.569.6-1.486,3.234-7.786,3.258,7.786.623,1.486,1.509,3.569a.68.68,0,0,0,.623.479.9.9,0,0,0,.359-.071.676.676,0,0,0,.455-.623A1.165,1.165,0,0,0,140.421,176.614Z",
    transform: "translate(-126.907 -161.999)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup466);
export default __webpack_public_path__ + "static/media/Group 466.6ddbcef02212e055dcb3371dc1c97be0.svg";
export { ForwardRef as ReactComponent };